/* Delegate so newly rendered theme-editor headers keep their controls. */
if (!window.adelaideMenusInitialized) {
  window.adelaideMenusInitialized = true;
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.adelaide-header .mega-menu[open]');
    if (!menu) return;
    menu.open = false;
    const summary = menu.querySelector('summary');
    summary.setAttribute('aria-expanded', 'false');
    summary.focus();
  });
  // Mobile accordion rows (buttons, so Dawn's drawer script leaves them alone).
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-adelaide-acc-toggle]');
    if (!toggle) return;
    event.preventDefault();
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    const body = document.getElementById(toggle.getAttribute('aria-controls'));
    if (body) body.hidden = expanded;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const toggle = event.target.closest('[data-adelaide-acc-toggle]');
    if (!toggle) return;
    event.preventDefault();
    toggle.click();
  });
  document.addEventListener('click', (event) => {
    const close = event.target.closest('.adelaide-drawer-close');
    if (!close) return;
    const drawer = close.closest('header-drawer');
    const trigger = drawer.querySelector(':scope > details > summary');
    drawer.closeMenuDrawer(event, trigger);
    trigger.setAttribute('aria-expanded', 'false');
  });
  const canHoverMenu = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const megaHoverHost = (node) => {
    if (!(node instanceof Element)) return null;
    const host = node.closest('header-menu');
    return host && host.closest('.adelaide-header') ? host : null;
  };
  let megaHoverTimer = 0;
  let megaHoverMenu = null;

  const setMegaMenuOpen = (details, open) => {
    if (!details) return;
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };

  // Anchor the compact panel under the hovered tab's text, hanging from the header's bottom edge.
  const positionMegaMenu = (details) => {
    const header = details.closest('.adelaide-navbar__inner') || details.closest('.header');
    const summary = details.querySelector('summary');
    const panel = details.querySelector('.adelaide-mega__panel');
    if (!header || !summary || !panel) return;
    const headerRect = header.getBoundingClientRect();
    const textRect = (summary.querySelector('span') || summary).getBoundingClientRect();
    if (details.classList.contains('adelaide-mega--more')) {
      panel.style.setProperty('--adelaide-mega-right', Math.max(0, Math.round(headerRect.right - textRect.right)) + 'px');
      return;
    }
    // Start under the tab text, but keep the whole panel inside the visible window (16px margin) on narrow desktops.
    const viewportRight = document.documentElement.clientWidth - 16;
    const minLeft = 16 - headerRect.left;
    const maxLeft = Math.max(minLeft, viewportRight - headerRect.left - panel.offsetWidth);
    const wanted = Math.max(0, Math.round(textRect.left - headerRect.left));
    panel.style.setProperty('--adelaide-mega-left', Math.round(Math.min(Math.max(wanted, minLeft), maxLeft)) + 'px');
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.open && details.classList.contains('adelaide-mega')) positionMegaMenu(details);
  }, true);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.adelaide-header details.adelaide-mega[open]').forEach(positionMegaMenu);
  });

  const keepMegaMenu = (details) => {
    if (!details) return;
    positionMegaMenu(details);
    window.clearTimeout(megaHoverTimer);
    megaHoverTimer = 0;
    document.querySelectorAll('.adelaide-header details.mega-menu[open]').forEach((openMenu) => {
      if (openMenu !== details) setMegaMenuOpen(openMenu, false);
    });
    megaHoverMenu = details;
    setMegaMenuOpen(details, true);
  };

  const releaseMegaMenu = (details) => {
    if (!details || megaHoverMenu !== details) return;
    window.clearTimeout(megaHoverTimer);
    megaHoverTimer = window.setTimeout(() => {
      if (megaHoverMenu !== details) return;
      if (details.matches(':hover')) return;
      setMegaMenuOpen(details, false);
      megaHoverMenu = null;
    }, 220);
  };

  document.addEventListener(
    'mouseenter',
    (event) => {
      if (!canHoverMenu()) return;
      const host = megaHoverHost(event.target);
      if (!host) return;
      keepMegaMenu(host.querySelector('details.mega-menu'));
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    (event) => {
      if (!canHoverMenu() || event.target.tagName !== 'HEADER-MENU') return;
      const host = megaHoverHost(event.target);
      if (!host) return;
      const next = event.relatedTarget;
      if (next instanceof Node && host.contains(next)) return;
      releaseMegaMenu(host.querySelector('details.mega-menu'));
    },
    true
  );

  // Priority+ navigation: keep the desktop bar on one row by moving trailing tabs into "View More".
  const fitAdelaideNav = () => {
    document.querySelectorAll('.adelaide-nav[data-visible-max]').forEach((nav) => {
      const list = nav.querySelector(':scope > ul');
      if (!list || !nav.offsetParent) return;
      const items = [...list.querySelectorAll(':scope > li[data-nav-index]')];
      const more = list.querySelector(':scope > li.adelaide-nav__more');
      if (!items.length || !more) return;
      const moreLinks = [...more.querySelectorAll('[data-more-index]')];
      const max = Math.min(parseInt(nav.dataset.visibleMax, 10) || items.length, items.length);
      const apply = (count) => {
        items.forEach((item, index) => {
          const hide = index >= count;
          if (hide && !item.hidden) item.querySelectorAll('details[open]').forEach((d) => setMegaMenuOpen(d, false));
          item.hidden = hide;
        });
        moreLinks.forEach((link) => { link.hidden = parseInt(link.dataset.moreIndex, 10) < count; });
        more.hidden = count >= items.length;
      };
      const fits = () => {
        const shown = [...list.children].filter((child) => !child.hidden);
        if (!shown.length) return true;
        const top = shown[0].offsetTop;
        return shown.every((child) => Math.abs(child.offsetTop - top) < 2) && list.scrollWidth <= list.clientWidth + 1;
      };
      let count = max;
      apply(count);
      while (count > 1 && !fits()) { count -= 1; apply(count); }
    });
  };
  let fitTimer = 0;
  const scheduleFit = () => { window.clearTimeout(fitTimer); fitTimer = window.setTimeout(fitAdelaideNav, 60); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleFit); else scheduleFit();
  window.addEventListener('load', scheduleFit);
  window.addEventListener('resize', scheduleFit);
  if ('ResizeObserver' in window) {
    const navObserver = new ResizeObserver(scheduleFit);
    const observeNavs = () => document.querySelectorAll('.adelaide-navbar__inner, .adelaide-nav').forEach((el) => navObserver.observe(el));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeNavs); else observeNavs();
    document.addEventListener('shopify:section:load', observeNavs);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
  document.addEventListener('shopify:section:load', scheduleFit);

  document.addEventListener('shopify:block:select', (event) => {
    const menu = event.target.closest('.mega-menu');
    if (menu) {
      menu.open = true;
      menu.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  });
}
